import React, { useRef } from 'react';
import { Play, Clock } from 'lucide-react';
import "../styles/VideoGallery.css";

// Componente para un video individual
const VideoCard = ({ video, onSelectVideo, isSelected }) => {
  const videoPreviewRef = useRef(null);

  const handleMouseEnter = () => {
    if (videoPreviewRef.current) {
      videoPreviewRef.current.currentTime = 1; // Mostrar un frame representativo
    }
  };

  return (
    <button
      type="button"
      className={`vcard${isSelected ? ' is-active' : ''}`}
      onClick={() => onSelectVideo(video)}
      onMouseEnter={handleMouseEnter}
      aria-current={isSelected ? 'true' : undefined}
    >
      <span className="vcard__thumb">
        <video
          ref={videoPreviewRef}
          src={video.src}
          muted
          preload="metadata"
          tabIndex={-1}
        />
        <span className="vcard__play" aria-hidden="true">
          <span>
            <Play size={14} fill="currentColor" />
          </span>
        </span>
      </span>

      <span className="vcard__meta">
        <span className="vcard__title">{video.title}</span>
        <span className="vcard__desc">{video.description}</span>
        <span className="vcard__time">
          <Clock size={11} style={{ verticalAlign: '-1px' }} aria-hidden="true" />
          {' '}{video.duration}
        </span>
      </span>
    </button>
  );
};

export default VideoCard;
